module.exports = __webpack_public_path__ + "img/72.f5003363.jpg";